"use client";

import Script from "next/script";

import useInteractionDeferred from "@/hooks/useInteractionDeferred";
import { env } from "@/env.mjs";

const LinkedInTrackerScript = () => {
  const ready = useInteractionDeferred();

  if (!env.NEXT_PUBLIC_ENABLE_PRODUCTION_FEATURES) return null;
  if (!ready) return null;

  return (
    <>
      <Script
        id="linkedin-tracker"
        strategy="lazyOnload"
        src="https://snap.licdn.com/li.lms-analytics/insight.min.js"
        async={true}
        onLoad={() => {
          if (typeof window !== "undefined") {
            window._linkedin_partner_id = "8094537";
            window._linkedin_data_partner_ids =
              window._linkedin_data_partner_ids || [];
            window._linkedin_data_partner_ids.push(window._linkedin_partner_id);

            if (!window.lintrk) {
              window.lintrk = function (a: any, b: any) {
                window.lintrk.q.push([a, b]);
              };
              window.lintrk.q = [];
            }
          }
        }}
      />
    </>
  );
};

export default LinkedInTrackerScript;
